import { render, staticRenderFns } from "./padApp.vue?vue&type=template&id=2cbb8fd0&scoped=true&"
import script from "./padApp.vue?vue&type=script&lang=js&"
export * from "./padApp.vue?vue&type=script&lang=js&"
import style0 from "./padApp.vue?vue&type=style&index=0&id=2cbb8fd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbb8fd0",
  null
  
)

export default component.exports